import React from 'react';
import PropTypes from 'prop-types';

export const ADDRESS_NEEDS_FIXING = 'Address needs fixing';

/**
 * Finite numbers, or numeric strings, matching PWA `statusShopMapCenter`.
 * Null, blank, NaN, and Infinity are not coordinates.
 */
export function finiteShopCoordinate(value) {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  if (
    typeof value === 'string' &&
    value.trim() !== '' &&
    Number.isFinite(Number(value))
  ) {
    return Number(value);
  }
  return null;
}

export function shopMapCenter(lat, lng) {
  const latitude = finiteShopCoordinate(lat);
  const longitude = finiteShopCoordinate(lng);
  if (latitude === null || longitude === null) {
    return null;
  }
  // A failed geocode is usually stored as the 0,0 default. One zero is a real coordinate.
  if (latitude === 0 && longitude === 0) {
    return null;
  }
  return [latitude, longitude];
}

export function shopAddressNeedsFixing(shop) {
  return !shop.address || typeof shop.address !== 'object';
}

export function shopBlocksAssign(shop) {
  if (!shop || shopAddressNeedsFixing(shop)) {
    return true;
  }
  return shopMapCenter(shop.lat, shop.lng) === null;
}

/** Finite distances stay in ascending order. Missing distances sort last, never as 0. */
export function compareAssignMeters(left, right) {
  const leftFinite = Number.isFinite(left);
  const rightFinite = Number.isFinite(right);
  if (leftFinite && rightFinite) {
    return left - right;
  }
  if (leftFinite) {
    return -1;
  }
  if (rightFinite) {
    return 1;
  }
  return 0;
}

class OrderErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <div>{ADDRESS_NEEDS_FIXING}</div>;
    }
    return this.props.children;
  }
}

OrderErrorBoundary.propTypes = {
  children: PropTypes.node
};

export default OrderErrorBoundary;
